/* Company Confidential, Copyright (c) 2021 Signant Health, Ltd. All Rights Reserved. */

import React from 'react';
import { useIntl } from 'react-intl';
import { Typography } from '@material-ui/core';
import Info from './Info';
import Checkbox from './Checkbox';
import { FORM_FIELDS } from '../consts';
import SaveScreenRow from './SaveScreenRow';
import FooterButtons from './FooterButtons';

export default function SaveScreen({
  values,
  files,
  validateConfirm,
  previous,
  error,
  onChange,
  message
}) {
  const { formatMessage } = useIntl();
  const { form } = values;
  const verifyComponent = (
    <Checkbox onChange={onChange} label={formatMessage({ id: 'general.confirm' })} />
  );
  const errorText = (
    <Typography color="error">{formatMessage({ id: 'general.confirmError' })}</Typography>
  );

  return (
    <div className="page">
      <div>
        {message !== formatMessage({ id: 'form.message' }) && message !== '' && (
          <Info text={message} />
        )}
        {FORM_FIELDS[form] &&
          FORM_FIELDS[form].map((field) => {
            if (field === 'upload') {
              return (
                <div key="upload" className="save row">
                  <div className="save-label-savescreen">
                    <Typography variant="h6">{`${formatMessage({ id: 'form.upload' })} :`}</Typography>
                  </div>
                  <div className="save-text">
                    {files.map((f) => (
                      <Typography key={f.name || f.path}>{f.name}</Typography>
                    ))}
                  </div>
                </div>
              );
            }
            if (values.userChangeType === 'Multi-user' && (field === 'userType' || field === 'userRole')) {
              return null;
            }
            return (
              <SaveScreenRow
                key={field}
                label={formatMessage({ id: `form.${field}` })}
                text={values[field] != null ? String(values[field]) : ''}
              />
            );
          })}
      </div>
      <div className="verify-container">
        <p className="verify-text">{formatMessage({ id: 'verify' })}</p>
        {verifyComponent}
        {error && errorText}
      </div>
      <FooterButtons previous={previous} next={validateConfirm} />
    </div>
  );
}
